export class ListCustomerTypeIdHelper {
    static NON_CONTRACT_USER = 1;
    static CONTRACT_USER = 2;
}